import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Avatar, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import { SURFACE_SX } from './customerDetailUtils';
import { pageColors } from '../HomePage';

const CustomerDetailHeader = memo(function CustomerDetailHeader({ backLabel, backTo, pageTitle }) {
  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Button
          component={Link}
          to={backTo}
          startIcon={<ArrowBackRoundedIcon fontSize="small" />}
          sx={{ textTransform: 'none', borderRadius: '999px' }}
        >
          {backLabel}
        </Button>
      </Stack>

      <Paper elevation={0} sx={{ ...SURFACE_SX, p: { xs: 2, md: 2.5 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'flex-start', md: 'center' }}
        >
          <Avatar sx={{ width: 48, height: 48, bgcolor: pageColors.customers }}>
            <PeopleAltOutlinedIcon />
          </Avatar>
          <Box>
            <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 2.5 }}>
              CRM
            </Typography>
            <Typography variant="h5" fontWeight={700}>
              {pageTitle}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Keep current CRM work, tenant-local context, and read-only Fortnox data in one account view.
            </Typography>
          </Box>
        </Stack>
      </Paper>
    </>
  );
});

export default CustomerDetailHeader;
